export default __webpack_public_path__ + "static/media/prezencne-pk-7-banner-graphics.69436ba2.svg";